import React, { useEffect, useState } from 'react';
import { Lock, MoveVertical } from 'lucide-react';
import { Switch } from '../ui/switch';
import { lockPrice, rMultiple } from './simMath';

const digitsOf = (o) => (o.pair?.includes('JPY') ? 3 : 5);

export const TrailControls = ({ o, onAuto, onMoveSl, busy }) => {
  const id = o.order_id;
  const auto = o.auto_trail !== false;
  const live = o.status === 'LIVE';
  const [sl, setSl] = useState(String(o.sl_price));
  useEffect(() => { setSl(String(o.sl_price)); }, [o.sl_price]);
  const r = live && o.current_price ? rMultiple(o, o.current_price) : null;
  const lock = lockPrice(o, 1, digitsOf(o));
  const better = o.direction === 'BUY' ? lock > o.sl_price : lock < o.sl_price;
  const lockReady = live && !auto && r >= 1.5 && better;
  const isBusy = busy === id;
  return (
    <div className="sim-trail" data-testid={`trail-controls-${id}`}>
      <div className="flex flex-wrap items-center gap-3">
        <label className="flex items-center gap-2 text-xs text-slate-300">
          <Switch checked={auto} disabled={isBusy} className="data-[state=checked]:bg-emerald-500 data-[state=unchecked]:bg-slate-600" onCheckedChange={(v) => onAuto(o, v)} data-testid={`auto-trail-switch-${id}`} />
          <span className="font-semibold" data-testid={`auto-trail-state-${id}`}>Auto-trail {auto ? 'ON' : 'OFF'}</span>
          <span className="text-slate-500">locks +1R at 1.5R</span>
        </label>
        {r != null && (
          <span className={`sim-mono text-xs font-semibold ${r >= 1.5 ? 'text-emerald-400' : 'text-slate-400'}`} data-testid={`live-r-${id}`}>
            {r >= 0 ? '+' : ''}{r.toFixed(2)}R
          </span>
        )}
      </div>
      {auto ? (
        <p className="text-[11px] text-slate-500" data-testid={`manual-sl-locked-${id}`}>Turn Auto-trail off to move the SL yourself.</p>
      ) : (
        <div className="flex flex-wrap items-center gap-2">
          <input type="number" step={digitsOf(o) === 3 ? 0.001 : 0.00001} value={sl} onChange={(e) => setSl(e.target.value)}
            className="sim-sl-input sim-mono" data-testid={`move-sl-input-${id}`} />
          <button type="button" className="sim-trail-btn" disabled={isBusy || !sl || Number(sl) === o.sl_price}
            onClick={() => onMoveSl(o, Number(sl))} data-testid={`move-sl-btn-${id}`}>
            <MoveVertical size={13} /> Move SL
          </button>
          {live && (
            <button type="button" className="sim-trail-btn sim-trail-lock" disabled={isBusy || !lockReady}
              onClick={() => onMoveSl(o, lock)} title={`Move SL to ${lock} (+1R) — available at 1.5R`} data-testid={`lock-1r-btn-${id}`}>
              <Lock size={13} /> Lock 1R
            </button>
          )}
        </div>
      )}
    </div>
  );
};
